import { useState } from 'react';
import saveSecondarySpecialty from '../api/saveSecondarySpecialty';
import deleteSecondarySpecialty from '../api/deleteSecondarySpecialty';

export default function useSecondarySpecialties(querySecondarySpecialities, selectedUser) {
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successBody, setSuccessBody] = useState('');
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState('');

    const _createSuccessMessage = (message) => {
        setShowSuccessModal(true);
        setSuccessBody(message);
    };

    const _createErrorMessage = (errorMessage) => {
        setShowErrorModal(true);
        setErrorBody(errorMessage);
    };

    const executeSaveSecondarySpecialty = async (selected) => {
        const attemptToSave = await saveSecondarySpecialty(selectedUser.id, selected, _createErrorMessage);
        if (attemptToSave) {
            _createSuccessMessage('Nueva especialidad agregada a perfil.');
        }
    };

    const onCloseSuccessMessage = () => {
        setShowSuccessModal(false);
        setSuccessBody('');
        querySecondarySpecialities();
    };

    const closeErrorMessage = () => {
        setShowErrorModal(false);
        setErrorBody('');
    };

    const onDeleteSecondarySpecialties = async (id) => {
        const attemptToDelete = await deleteSecondarySpecialty(selectedUser.id, id, _createErrorMessage);
        if (attemptToDelete) {
            _createSuccessMessage('Nueva especialidad eliminada del perfil.');
        }
    };

    return {
        executeSaveSecondarySpecialty,
        showSuccessModal,
        successBody,
        onCloseSuccessMessage,
        showErrorModal,
        errorBody,
        closeErrorMessage,
        onDeleteSecondarySpecialties
    };
}
